import React from "react";
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import { CmpDatePicker } from "../../../Component/Common/ToolBox/ToolBox";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";

const HeaderComponent = ({
  status,
  handleLoadBtn = () => {},
  filterObj,
  setFilterObj,
  vRdxDBLocation = [],
  handleExport = () => {},
  title="",
}) => {
  // Media Queries for Responsiveness
  const isMobile = useMediaQuery("(max-width:650px)");
  const isTabOrDesktop = !isMobile;

  const handleStatusChange = (event) => {
    setFilterObj((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };

  return (
    <div className="stock-detail">
      <Grid
        container
        columnSpacing={{ xs: 1, sm: 1.5, md: 2, lg: 4 }}
        rowSpacing={{ xs: 1.5, sm: 1, md: 2, lg: 2 }}
        marginTop={{ xs: 0.5, sm: 0.5, md: 1, lg: 1 }}
      >
        <Grid item xs={12} sm={3} md={2}>
          <Typography>From Date</Typography>
          <CmpDatePicker
            xValue={filterObj?.dateFrom}
            xOnChange={(newValue) =>
              setFilterObj((obj) => ({
                ...obj,
                dateFrom: newValue.$d,
              }))
            }
            xName={"dateFrom"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <Typography>To Date</Typography>
          <CmpDatePicker
            style={{ width: "100% !important" }}
            xValue={filterObj?.dateTo}
            xOnChange={(newValue) =>
              setFilterObj((obj) => ({
                ...obj,
                dateTo: newValue.$d,
              }))
            }
            xName={"dateTo"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        
       
        <Grid
          item
          xs={12}
          sm={8}
          md={8}
          display={isMobile ? "" : "flex"}
          justifyContent={isMobile ? "center" : "flex-end"}
          textAlign={isMobile ? "center" : "flex-end"}
          gap={2}
        >
          <Button
            variant="contained"
            sx={{
              width: isMobile ? "80px" : "100px",
              mt: isMobile ? 1 : 2,
              textTransform: "capitalize",
            }}
            onClick={handleLoadBtn}
          >
            Load
          </Button>
            <Tooltip title="Export CSV" sx={{mt:2}}>
                        <IconButton color="primary" onClick={handleExport} size="small">
                          <DownloadOutlinedIcon/>
                        </IconButton>
                      </Tooltip>
        </Grid>
      </Grid>
    </div>
  );
};

export default HeaderComponent;
